import cn from 'classnames';

import styles from './DescriptionList.module.scss';

interface DescriptionListProps {
  list: Record<string, string | number>;
  title?: string;
  fontSize?: 'small' | 'body' | 'micro';
  className?: string;
  titleClassname?: string;
}

export function DescriptionList({
  list,
  title,
  fontSize = 'small',
  className,
  titleClassname,
}: DescriptionListProps) {
  return (
    <div className={styles.container}>
      {title && (
        <p
          className={cn(styles.title, titleClassname, {
            [styles.body]: fontSize === 'small',
            [styles.small]: fontSize === 'micro',
          })}
        >
          {title}
        </p>
      )}
      <dl className={cn(className)}>
        {Object.entries(list).map(([term, description]) => (
          <div key={`${term}: ${description}`}>
            <dt className={cn(styles.term, styles[fontSize])}>{term}:</dt>
            <dd className={cn(styles.description, styles[fontSize])}>
              {description}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
